/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-modal.scss'
import template from 'lui-modal.html'

export const WINDOW_FRAME_OFFSET = 20

export default class LuiModal extends LuiBase {
  static get is() {
    return 'lui-modal'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  onConnected() {
    super.onConnected()
    this.delay(() => {
      this._registerEvents()
    })
  }

  onDisconnected() {
    super.onDisconnected()
    this._unregisterEvents()
  }

  openChanged(oldValue, newValue) {
    if (newValue !== null) {
      this._hideControlsIfEmpty()
      this.overlay.show()
    } else {
      this.overlay.close()
    }
  }

  xcloseableChanged(oldValue, newValue) {
    if (newValue !== null) {
      this.overlay.addEventListener('lui-clear:clicked', this._onClearClickedBound)
    }
  }

  bgcloseableChanged(oldValue, newValue) {
    if (newValue !== null) {
      this.overlay.addEventListener('click', this._onOverlayClickedBound)
    }
  }

  get overlay() {
    this._overlay = this._overlay || this.shadowRoot.querySelector('lui-overlay')
    return this._overlay
  }

  _hideControlsIfEmpty() {
    const visibleControls = Array.from(this.querySelectorAll('[slot="controls"]'))
      .filter(this._isVisible)

    if (!this.querySelector('[slot="controls"]') || visibleControls.length === 0) {
      this.shadowRoot.querySelector('.lui-modal__content-controls').style.display = 'none'
    } else {
      this.shadowRoot.querySelector('.lui-modal__content-controls').style.display = 'flex'
    }
  }

  _isVisible(element) {
    return window.getComputedStyle(element).display !== 'none'
  }

  _registerEvents() {
    this._onClearClickedBound = this._onClearClickedBound || this._onClearClicked.bind(this)
    this._onOverlayClickedBound = this._onOverlayClickedBound || this._onOverlayClicked.bind(this)

    if (this.hasAttribute('xcloseable')) {
      this.overlay.addEventListener('lui-clear:clicked', this._onClearClickedBound)
    }
    if (this.hasAttribute('bgcloseable')) {
      this.overlay.addEventListener('click', this._onOverlayClickedBound)
    }
  }

  _onClearClicked(event) {
    this.removeAttribute('open')
  }

  _onOverlayClicked(event) {
    if (!event.target.closest('.lui-modal__content') && this.hasAttribute('bgcloseable')) {
      this.removeAttribute('open')
    }
  }

  _unregisterEvents() {
    this.overlay.removeEventListener('lui-clear:clicked', this._onClearClickedBound)
    this.overlay.removeEventListener('click', this._onOverlayClicked)
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-modal/lui-modal.js
// module id = 271
// module chunks = 0 1 31